import '../styles/global.scss';
import { saleBannerMessages } from '@app/components/SaleBanner/messages';
import { RedbubbleApp } from '@redbubble/next/app';
import type { ComponentProps } from 'react';

export default function App(
  props: Omit<ComponentProps<typeof RedbubbleApp>, 'saleBannerMessages'>
) {
  return <RedbubbleApp {...props} saleBannerMessages={saleBannerMessages} />;
}
